import Paper from '@mui/material/Paper';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import React, { useState } from 'react';
import { locationCategories } from '../../content/locationCategories';
import DestinationItem from './DestinationItem';

export default function CountryList({ locations }) {
  const [value, setValue] = useState(0);
  const [countries, setCountries] = useState(locations);

  const handleTabReset = () => {
    setValue(0);
    setCountries(locations);
  };

  const handleOpenAll = () => {
    setValue(1);
    setCountries(locations);
  };

  const handleTabChange = (region, i) => () => {
    setValue(i + 2);
    const newCountries = [];
    locations.forEach(country => {
      if (country.regions && country.regions.indexOf(region) !== -1) {
        newCountries.push(country);
      }
    });
    setCountries(newCountries);
  };

  return (
    <>
      <Paper square>
        <Tabs
          value={value}
          indicatorColor="primary"
          textColor="primary"
          scrollButtons
          variant="scrollable"
          allowScrollButtonsMobile
        >
          <Tab label="Featured" onClick={handleTabReset} />
          <Tab label="All" onClick={handleOpenAll} />
          {locationCategories.map((title, i) => (
            <Tab
              key={title}
              label={title}
              onClick={handleTabChange(title, i)}
            />
          ))}
        </Tabs>
      </Paper>
      <div className="tw-container tw-m-auto tw-mt-3">
        <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 lg:tw-grid-cols-3 xl:lg:tw-grid-cols-4 tw-gap-3">
          {countries &&
            countries.length > 0 &&
            countries.map((location, i) => {
              if (value !== 0 || location.isFeatured)
                return (
                  <div key={location.countryCode}>
                    <DestinationItem destination={location} isPrio={i < 8} />
                  </div>
                );
            })}
        </div>
      </div>
    </>
  );
}
